import React, { useMemo } from 'react';

import Detail from '../../Detail';
import AddUser from './Add';
import Table from './Table';
import { useAuth } from 'hooks';

const Users = ({
  value,
  onChange,
  activeList,
  options,
  currentUser,
  loading,
}) => {
  const { user } = useAuth();

  const filteredOptions = useMemo(
    () => options.filter(option => option.email !== user.userEmail),
    [options, user.userEmail]
  );

  return (
    <Detail label='Per-user permissions' style={{ marginTop: 15 }}>
      <AddUser
        tableData={value}
        setTableData={onChange}
        list={activeList}
        allUsers={filteredOptions}
        loading={loading}
      />
      <Table
        tableData={value}
        setTableData={onChange}
        listOwner={activeList.createdByUserId}
        currentUser={currentUser}
      />
    </Detail>
  );
};

Users.defaultProps = {
  activeList: {},
};

export default Users;
